import mutations from './mutations.js'
import actions from './actions.js'
import getters from './getters.js'

export default {
  state() {
    return {
      titleMenus: null,
      dataMenus: null,
      dataRoles: null,
      editMenu: null,
      dataUsers: null,
      permissionUser: null,
    };
  },
  mutations,
  actions,
  getters
}